import { createDomain } from 'effector';

const domain = createDomain('i18n');

const $$i18n = {
    localesLoaded: domain.event(),
};

export default $$i18n;
